import { extendTheme } from "@chakra-ui/react";
import { theme } from "../theme/theme";
import buttonBase from "./buttonBase";

const chakraDefaultTheme = {
  colors: {
    ...theme.colors,
  },
  fonts: {
    body: "Pretendard Variable, Apple SD Gothic Neo",
  },
  // https://chakra-ui.com/docs/theming/component-style#styling-single-part-components
  components: {
    Button: buttonBase,
  },
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  styles: {
    global: {
      // 전역 스타일 없음 - Chakra UI 기본 동작 유지
      // BaseStack 컴포넌트에서 spacing 관리
    },
  },
};

export const chakraTheme = extendTheme(chakraDefaultTheme);
